import React from "react"
import { observer } from "mobx-react-lite"
import { Navigate } from "react-router-dom"

import MainLayout from "@components/layout/MainLayout/MainLayout"
import Text from "@components/ui/Typography/Text"
import {
  copilotStudioTransport,
  copilotStudioWebchatUrl,
  isCopilotStudioIframeReady,
} from "@framework/constants/copilot-studio"
import mainRoutes from "@root/main.routes"
import { useStore } from "@store/index"

import CopilotStudioSdkChat from "./CopilotStudioSdkChat"
import styles from "./CopilotStudioPage.module.sass"

/**
 * Portal host for the Copilot Studio agent webchat.
 * Separate from Fact Finder — existing /home and solutions routes are untouched.
 */
const CopilotStudioPage: React.FC = observer(() => {
  const { restrictionsStore } = useStore()
  if (!restrictionsStore.showCopilot) {
    return <Navigate to={mainRoutes.home()} replace />
  }

  return (
    <MainLayout noPadding className={styles.root}>
      {copilotStudioTransport === "sdk" ? (
        <CopilotStudioSdkChat />
      ) : isCopilotStudioIframeReady ? (
        <iframe
          className={styles.frame}
          title="LabWizard Copilot Studio"
          src={copilotStudioWebchatUrl}
          allow="microphone; clipboard-read; clipboard-write"
          referrerPolicy="strict-origin-when-cross-origin"
        />
      ) : (
        <div className={styles.empty}>
          <Text variant="h3" as="h1">
            Copilot Studio is not configured
          </Text>
          <Text variant="body2" color="text70Color">
            Set REACT_APP_COPILOT_STUDIO_WEBCHAT_URL to the agent webchat URL
            from Copilot Studio (Web app channel), then rebuild the frontend.
          </Text>
        </div>
      )}
    </MainLayout>
  )
})

export default CopilotStudioPage
